import { inject, observer } from "mobx-react";
import AgGrid from "../../../common/components/ag-grid/ag-grid";
import React, { Component } from "react";
import {
  faFileExport,
  faPlus,
  faSave,
  faSync,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import {
  ADD_NEW_USER,
  DIFF_GRP_ERROR_MSG,
  EDIT_USER,
  EXPORT,
  REFRESH,
  SAME_GRP_ERROR_MSG,
  gridOptions
} from "../constants/outage-user-management";
import UserFacilityMapping from "./user-facility-mapping";
import '../component/outage-schedule-report-component.scss';

@inject('OutageScheduleUserStore', 'CommonStore')
@observer
class OutageUserManagement extends Component {
  constructor(props) {
    super(props)
    this.state = {
      gridOptions: {
        ...gridOptions,
        onRowDoubleClicked: () => this.operationHandler('VIEW')
      },
      isRowSelected: false,
      isFacilityMappingVisible: false,
      selectedRow: null,
      isAddMode: false,
      isViewMode: false
    }
  }

  async componentDidMount() {
    const {
      OutageScheduleUserStore: { getCurrentScreen, getGridColumns },
      CommonStore: { screenDetails },
      path
    } = this.props
    const currentScreen = getCurrentScreen(path, screenDetails)
    getGridColumns(currentScreen)
    this.refreshData()
  }

  refreshData = async () => {
    const {
      OutageScheduleUserStore: { getCurrentScreen, getGridData },
      CommonStore: { screenDetails },
      path,
      CommonStore
    } = this.props
    const currentScreen = getCurrentScreen(path, screenDetails)
    await getGridData(currentScreen, CommonStore)
  }

  onSelectionChanged = () => {
    const { gridOptions } = this.state
    const selectedRow = gridOptions.api.getSelectedRows()
    this.setState({ selectedRow: selectedRow[0], isRowSelected: true })
  }

  exportToExcel = () => {
    const {
      OutageScheduleUserStore: { getCurrentScreen },
      CommonStore: { screenDetails },
      path
    } = this.props
    const { gridOptions } = this.state
    const currentScreen = getCurrentScreen(path, screenDetails)
    const sheetName = currentScreen.screen.title.split(' ').join('_')
    const date = moment(new Date()).format('YYYYMMDDhhmmss')
    const fileName = `${sheetName} _Export_All_ ${date}`
    gridOptions.api.exportDataAsExcel({
      fileName,
      sheetName,
      processCellCallback: (params) => {
        if (params.column.colId === "GroupId") {
          let refLookupData = currentScreen.screenColumns
            .find(item => item.name === params.column.colId).refLookupData
          refLookupData = refLookupData?.lookupValues?.values || []
          const matchingLabel = refLookupData
            .find(item => item.value == params.value)?.label || null
          return matchingLabel
        }
        if (['CreatedOn', 'UpdatedOn'].includes(params.column.colId) && params?.value) {
          return moment(new Date(params?.value.toString())).format('MM/DD/YYYY')
        }
        return params.value
      }
    })
  }

  childHandler = () => {
    const { OutageScheduleUserStore } = this.props
    this.setState({
      isFacilityMappingVisible: false,
      selectedRow: null,
      isAddMode: false,
      isViewMode: false,
      isRowSelected: false
    })
    OutageScheduleUserStore.ufmRowData = []
  }

  operationHandler = (operation) => {
    if (operation === 'ADD') {
      this.setState({ isFacilityMappingVisible: true, isAddMode: true })
    } else if (operation === 'EDIT') {
      this.setState({ isFacilityMappingVisible: true })
    } else if (operation === 'VIEW') {
      const selectedRow = this.state.gridOptions.api.getSelectedRows();
      this.setState({
        isFacilityMappingVisible: true,
        isViewMode: true,
        selectedRow: selectedRow[0]
      })
    }
  }

  saveScreenData = async (fields, ufmGridOptions) => {
    const {
      CommonStore,
      OutageScheduleUserStore,
      OutageScheduleUserStore: { getCurrentScreen, rowData },
      path,
    } = this.props
    const { isAddMode } = this.state
    let errMsg = null
    const action = isAddMode ? 'Save' : 'Update'
    const currentScreen = getCurrentScreen(path, CommonStore.screenDetails)

    // Check Whether user exists? Yes, then in same or different group
    const activeUser = rowData.filter(row => row.EmailId.toLowerCase()
      === fields.EmailId.toLowerCase() && row.IsActive === true
    )
    const sameGroup = activeUser.filter(usr =>
      parseInt(usr.GroupId) === parseInt(fields.GroupId)
    )
    const diffGroup = activeUser.filter(usr =>
      parseInt(usr.GroupId) !== parseInt(fields.GroupId)
    )

    if (action === 'Save' || (action === 'Update' && fields.IsActive === true &&
      activeUser?.[0]?.ID !== fields?.ID)) {
      if (sameGroup?.length)
        errMsg = SAME_GRP_ERROR_MSG
      if (diffGroup?.length)
        errMsg = DIFF_GRP_ERROR_MSG
    }
    // Display Same/Different Group Error OR perform Add/Update Record
    if (errMsg) {
      window.toastr.error(errMsg)
    } else {
      delete fields.Region
      await OutageScheduleUserStore.saveScreenData(
        fields,
        CommonStore,
        currentScreen,
        action,
        ufmGridOptions,
        isAddMode
      )
      this.childHandler()
      this.refreshData()
    }
  }

  render() {
    const { gridOptions, isRowSelected, isFacilityMappingVisible } = this.state
    const { OutageScheduleUserStore: { rowData, colDefs }, path } = this.props
    const ufmProps = {
      ...this.state,
      userMgmtpath: path,
      formHandler: this.childHandler,
      saveScreenData: this.saveScreenData
    }
    return (
      <>
        <div className="outg-row">
          <h3 className="outg-title">User Management</h3>
        </div>
        {!isFacilityMappingVisible &&
          <>
            <div className="outg-row">
              <AgGrid
                gridOptions={gridOptions}
                columnDefs={colDefs}
                rowData={rowData}
                rememberGroupStateWhenNewData={true}
                onSelectionChanged={this.onSelectionChanged}
              />
            </div>
            <div className="outg-row outg-row-justify">
              <Buttton
                icon={faPlus}
                onClick={() => this.operationHandler('ADD')}
                title={ADD_NEW_USER}
                disabled={false}
              />
              <Buttton
                icon={faSave}
                onClick={() => this.operationHandler('EDIT')}
                title={EDIT_USER}
                disabled={!isRowSelected}
              />
              <Buttton
                icon={faFileExport}
                onClick={this.exportToExcel}
                title={EXPORT}
                disabled={false}
              />
              <Buttton
                icon={faSync}
                onClick={this.refreshData}
                title={REFRESH}
                disabled={false}
              />
            </div>
          </>
        }
        {isFacilityMappingVisible && <UserFacilityMapping {...ufmProps} />}
      </>
    )
  }
}

const Buttton = (props) => {
  const { onClick, title, icon, disabled } = props
  return (
    <button
      type="button" // button\reset\submit
      className="btn btn-primary btn-grid active"
      aria-expanded="false"
      disabled={disabled}
      onClick={onClick}
    >
      <FontAwesomeIcon icon={icon} />
      <span style={{ marginLeft: '5px' }}>{title}</span>
    </button>
  )
}

export default OutageUserManagement